import { jsx as _jsx } from "react/jsx-runtime";
import Button from '../button';
import { useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { notificationStatusMapping } from './consts';
import { useNotificationContext } from './context';
/** Displays an action button within the Notification. */
export const NotificationButton = vui((props, ref) => {
    const { className, ...rest } = props;
    const mergedProps = { ...useNotificationContext(), ...props };
    const styles = useStyleConfig('Notification', useNotificationContext());
    const { status = '' } = mergedProps;
    const { variant } = notificationStatusMapping[status] ?? {};
    return (_jsx(Button, { className: cs('vui-notificationButton', className), ml: "0px", mr: "16px", my: "16px", px: "12px", py: "6px", ref: ref, ...styles.button, variant: variant, ...rest }));
});
NotificationButton.displayName = 'NotificationButton';
export default NotificationButton;
